import React, {
  MutableRefObject, useCallback, useContext,
} from 'react';
import Webcam from 'react-webcam';

import { useDispatch, useSelector } from 'react-redux';
import WebcamStreamCapture from './WebcamStreamCapture';
import { UploadRecordContext } from '../record/UploadRecordContext';
import { StudioPreventChangeRouteModal } from '../modal/StudioPreventChangeRouteModal';
import { setCameraRecording } from '../../../store/modules/studio/actions';
import { selectCameraRecording } from '../../../store/modules/studio/selectors';
import { studioPreventChangeRouteModalStyles } from '../styles';

type Props = {
  webcamRef: MutableRefObject<Webcam & HTMLVideoElement | null>;
};

const CameraComponent = ({ webcamRef }: Props) => {
  const { streamData, cancelAll } = useContext(UploadRecordContext);
  const modalClasses = studioPreventChangeRouteModalStyles();
  const isRecording = useSelector(selectCameraRecording);
  const dispatch = useDispatch();
  const someFileUploading = streamData.some((item) => item.status === 'uploading' || item.status === 'ready') || isRecording;

  const approveCb = useCallback(() => {
    const timer = setTimeout(() => {
      cancelAll();
      clearTimeout(timer);
    }, 0);
  }, [cancelAll]);

  const cbWhenOpen = useCallback(() => {
    if (isRecording) {
      dispatch(setCameraRecording(false));
    }
  }, [isRecording, dispatch]);


  return (
    <>
      <StudioPreventChangeRouteModal cbWhenOpen={cbWhenOpen} conditionForModalOpening={someFileUploading} approveCb={approveCb} customModalStyles={{ ...modalClasses }} />
      <WebcamStreamCapture webcamRef={webcamRef} />
    </ >
  );
};


export default CameraComponent;
